export default {
  namespaced: true,
  state:{
    dailyLettersReasons: [],
    dailyLettersReasonCreate: {
      modal: false,
      values: {}
    },
    dailyLettersReasonEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    dailyLettersReasons(state){
      return state.dailyLettersReasons;
    },
    dailyLettersReasonCreate(state) {
        return state.dailyLettersReasonCreate;
    },
    dailyLettersReasonEdit(state) {
      return state.dailyLettersReasonEdit;
    }
  },
  mutations:{
    SET_DAILY_LETTERS_REASONS(state, values){
      state.dailyLettersReasons = values;
    },
    SET_DAILY_LETTERS_REASON_CREATE_MODAL(state, value) {
      state.dailyLettersReasonCreate.modal = value;
    },
    SET_DAILY_LETTERS_REASON_CREATE_VALUES(state, value) {
      state.dailyLettersReasonCreate.values = value;
    },
    SET_DAILY_LETTERS_REASON_EDIT_MODAL(state, value) {
      state.dailyLettersReasonEdit.modal = value;
    },
    SET_DAILY_LETTERS_REASON_EDIT_VALUES(state, value) {
      state.dailyLettersReasonEdit.values = value;
    },
    PUSH_DAILY_LETTERS_REASON(state, value){
      state.dailyLettersReasons.push(value);
    },
    SET_UPDATE_DAILY_LETTERS_REASON(state, values){
      var editedIndex = state.dailyLettersReasons.map(reason => reason.id).indexOf(values.id);
      if (editedIndex > -1){
        Object.assign(state.dailyLettersReasons[editedIndex], values);
      }
      return;
    },
    SPLICE_DAILY_LETTERS_REASON(state, value){
      let i = state.dailyLettersReasons.map(reason => reason.id).indexOf(value);
      state.dailyLettersReasons.splice(i, 1);
    }
  },
  actions:{
    getDailyLettersReasons({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/daily-letters-reasons').then((response) => {
          commit('SET_DAILY_LETTERS_REASONS', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    dailyLettersReasonStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/daily-letters-reasons', formData).then((response) => {
          commit('PUSH_DAILY_LETTERS_REASON', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    dailyLettersReasonUpdate({commit}, payload) {
      var value = payload.id;
      return new Promise((resolve, reject) => {
        axios.put('admin/daily-letters-reasons/' + value, payload).then((response) => {
          commit('SET_UPDATE_DAILY_LETTERS_REASON', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteDailyLettersReason({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/daily-letters-reasons/' + value).then((response) => {
          commit('SPLICE_DAILY_LETTERS_REASON', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
  }
}
